import { ToastProgrammatic as Toast } from 'buefy'
import { NotificationProgrammatic as Notification } from 'buefy'
export default function log(type = 'dark', text) {
  Notification.open({
    duration: 5000,
    message: text,
    position: 'is-bottom-right',
    type: `is-${type}`
  })
}
